export default __webpack_public_path__ + "static/media/visualstudio_code-icon.8b18e9e2.svg";